// extracted by mini-css-extract-plugin
export default {"heading":"Fm-z","createAccount":"Gm-z","disabled":"Hm-z","copy":"Im-z","terms":"Jm-z"};